import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsZcConstants {
    static STEP_TITLE = "Details";
    static DESCRIPTION_LBL = "Description";
    static TYPE_LBL = "Application type";
    static DESCRIPTION_CTRL = "description";
    static TYPE_CTRL = "type";
    static APPLICATION_PLACE_HOLDER = "Application place holder";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        type: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
